import React, { useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";
import AuthApi from "../../api/authApi";
//import { Cookies, useCookies } from "react-cookie";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import axios from 'axios';

const Login = () => {
    const navigate = useNavigate();
    const { instance } = useMsal();
    let api = new AuthApi();

    const [data, setData] = useState({
        email: "",
        password: ""
    });
    const [validated, setValidated] = useState(false);
    const [, setCookie] = useCookies(['PDATokenStage', 'PDAUserStage']);
    const [showResetPassword, setShowResetPassword] = useState(false);
//    const cookies = new Cookies();
	
    const handleLoginSubmit = async (event) => {
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        if (form.checkValidity() === true) {
            await api.Login(data).then((response) => {
                if (response.success) {
                    setCookie(
                        'PDATokenStage',
                        response.token,
                        {
                            path: '/',
                            maxAge: 60 * 60 * 100,
                            expires: new Date(Date.now() + 60 * 60 * 100),
                        }
                    );
                    setCookie('PDAUserStage', response, {
                        path: '/',
                        maxAge: 60 * 60 * 100,
                        expires: new Date(Date.now() + 60 * 60 * 100),
                    });
                    navigate('/pda-model');
                    toast.success(response.msg);
					setValidated(true);
                } else {
                    alert(response.msg);
                }
            }).catch(() => {
                alert("Email and Password is mismatched.");
            });
        } else {
            alert("User Name and Password is required");
        }
    };

	const handleAzureLogin = async () => {
	    try {
	        const response = await instance.loginPopup(loginRequest);
	        console.log("azure response..", response);
	        const token = response.idToken;
	        axios.defaults.headers.common["Authorization"] = "Bearer " + token;
	        
	        const data = await api.AzureLogin({ token });
	        
	        if (data.success) {
	            setCookie('PDATokenStage', data.token, {
	                path: '/',
	                maxAge: 12 * 60 * 60,
	                expires: new Date(Date.now() + 12 * 60 * 60 * 1000)
	            });
	            setCookie('PDAUserStage', data, {
	                path: '/',
	                maxAge: 12 * 60 * 60, 
	                expires: new Date(Date.now() + 12 * 60 * 60 * 1000) 
	            });
	            navigate('/pda-model');
	            toast.success(data.msg);
	        } else {
	            console.log("Login from backend failed:", data);
	            alert(data.msg);
	        }
	    } catch (err) {
	        console.log("Login failed:", err);
	       if (err.errorCode === "interaction_in_progress") {
	            alert("A login window is already open. Please complete or close it first, then try again.");
	        } else if (err.errorCode === "user_cancelled") {
	            console.log("User cancelled login");
	        } else if (err.errorCode === "popup_window_error") {
	            alert("Please close any existing login windows and try again.");
			} else if (err.response?.status === 403) {
                console.log("status 403");
				alert(err.response.data.msg || "Access denied. Please contact IT department.");
//				handleLogout();
			} else if (err.response?.status === 401) {
				alert("Session expired. Please login again.");
//				handleLogout();
			} else {
				alert("Login failed. Please reload the page once and try again, else contact RLG IT department");
			}
	    }
	};
	  
	/* Logout handler
	const handleLogout = () => {
		// Clear cookies
        cookies.remove('PDATokenStage', { path: '/' });
        cookies.remove('PDAUserStage', { path: '/' });
		
		// Clear local storage
		localStorage.removeItem('msalAccount');
		
		// Clear axios header
		delete axios.defaults.headers.common["Authorization"];
		
		// MSAL logout
		instance.logoutPopup({
			mainWindowRedirectUri: "/"
		});
	};
	*/
    const handleResetPasswordSubmit = async (event) => {
        event.preventDefault();
        if (data.email) {
            let authApi = new AuthApi();
            await authApi.ForgotPassword(data.email)
                .then((response) => {
                    if (response.success === true) {
                        toast.success(response.msg);
                    } else {
                        toast.error(response.msg);
                    }
                })
                .catch((error) => {
                    toast.error(error);
                });
            setShowResetPassword(false);
        }
    };

    const handleChanges = async (e) => {
        const { name, value } = e.target;
        setData(prev => ({ ...prev, [name]: value }));
    };

    return (
        <div className="container-fluid page-body-wrapper full-page-wrapper">
            <div className="content-wrapper d-flex align-items-center auth">
                <div className="row flex-grow">
                    <div className="col-lg-4 mx-auto">
                        <div className="auth-form-light text-left p-5">
                            <div className="brand-logo">
                                PDA-Model
                            </div>
                            <h4>Hello! let&apos;s get started</h4>
                            <h6 className="font-weight-light">Sign in to continue.</h6>
                            <Form
                                onSubmit={handleLoginSubmit}
                                noValidate
                                validated={validated}
                                className="pt-3"
                            >
                                {/* <Form.Group>
                                    <Form.Control
                                        required
                                        type="text"
                                        name="email"
                                        placeholder="Email"
                                        value={data.email}
                                        onChange={handleChanges}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Email is required!
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <br />
                                <Form.Group>
                                    <Form.Control
                                        required
                                        type="password"
                                        name="password"
                                        placeholder="Password"
                                        value={data.password}
                                        onChange={handleChanges}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        Password is required!
                                    </Form.Control.Feedback>
                                </Form.Group>

                                <button
                                    type="button"
                                    onClick={() => setShowResetPassword(true)}
                                    className="btn btn-link p-0"
                                    style={{ float: 'right' }}
                                >
                                    Forgot Password
                                </button>
                                <br /><br /> */}

                                <div className="d-flex flex-column gap-3">
                                    {/* <Button type="submit" className="btn btn-block btn-primary btn-lg font-weight-medium auth-form-btn">
                                        SIGN IN
                                    </Button> */}

                                    <Button
                                        onClick={handleAzureLogin}
                                        className="btn btn-block btn-info btn-lg font-weight-medium auth-form-btn"
                                    >
                                        Sign in with Azure
                                    </Button>
                                </div>
                            </Form>
                        </div>
                    </div>

                    <Modal show={showResetPassword} onHide={() => setShowResetPassword(false)}>
                        <Modal.Header closeButton>
                            <Modal.Title>Reset Password</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Form onSubmit={handleResetPasswordSubmit}>
                                <Form.Group>
                                    <Form.Label>Email address</Form.Label>
                                    <Form.Control
                                        type="email"
                                        placeholder="Enter email"
                                        name="email"
                                        value={data.email}
                                        onChange={handleChanges}
                                        required
                                    />
                                </Form.Group>
                                <br />
                                <Button variant="primary" type="submit">
                                    Send Reset Link
                                </Button>
                            </Form>
                            <p className="mt-2">
                                A reset link will be sent to your email. Please check your inbox (and spam/junk folder) for further instructions.
                            </p>
                        </Modal.Body>
                    </Modal>

                </div>
            </div>
        </div>
    );
};

export default Login;